import React from "react";
import styled from "styled-components";
import { Upload as AntdUpload } from "antd";
import { Title } from "./Text";
import { Flex } from "./Flex";


const StyledUpload = styled(AntdUpload).attrs({
    showUploadList: false
})``;

const StyledUploadDragger = styled(AntdUpload.Dragger).attrs(({ customRequest }) => ({
    showUploadList: false,
    openFileDialogOnClick: false,
    customRequest: customRequest,
    className: "upload-overlay"
}))`
    & > .ant-upload {
        display: block;
        padding: 0;
    }
`;

const StyledUploadOverlay = styled(Flex).attrs({
    id: "drag-and-drop-overlay",
    position: "absolute",
    background: "rgba(24, 60, 120, 0.7)",
    padding: { top: "6rem", right: "6rem", bottom: "6rem", left: "6rem" }
})`
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 0%;
    z-index: 1010;
    visibility: hidden;
    transition: ease all 0.5s;
`;

const StyledUploadOverlayContent = styled(Flex).attrs({
    flex: 1,
    justify: "center",
    align: "center"
})`
    border: 8px dashed #EFF6FF;
    border-radius: 50px;
`;

const Upload = (props) => <StyledUpload {...props} />;

Upload.Dragger = ({ children, ...props }) => {

    return(
        <StyledUploadDragger {...props}>
            {children}
            <StyledUploadOverlay>
                <StyledUploadOverlayContent>
                    <Title style={{ fontSize: "5vw", textTransform: "uppercase", letterSpacing: "0.15px" }} color="#FFFFFF">Drop files here to upload</Title>
                </StyledUploadOverlayContent>
            </StyledUploadOverlay>
        </StyledUploadDragger>
    )
};

export { Upload };